"use client"

import { SprayCan } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SprayCanIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SprayCanIcon = component(Icon)({ as: SprayCan })
